import { gql, useMutation } from '@apollo/client';

const ABORT_AND_REMOVE_SCAN_RESULT = gql`
  mutation AbortAndRemoveScanResult($propertyId: String!) {
    abortAndRemoveScanResult(propertyId: $propertyId)
  }
`;

interface AbortAndRemoveScanResultInput {
  propertyId: string;
}

interface AbortAndRemoveScanResultData {
  abortAndRemoveScanResult: boolean;
}

export function useScanResultAbortMutation() {
  return useMutation<AbortAndRemoveScanResultData, AbortAndRemoveScanResultInput>(ABORT_AND_REMOVE_SCAN_RESULT, {
    refetchQueries: ['GetUser', 'GetCompany'],
  });
}
